import PropTypes from "prop-types";
import React from "react";
import Form from "react-bootstrap/Form";

import FormInputError from "./FormInputError";

function FormInputControl(props) {
  const {
    accept,
    formPlaceholder,
    formAriaLabel,
    describedBy,
    inputType,
    className,
    name,
    formik,
    checked,
    value,
    disabled,
    showError,
    onChange,
    rows,
    max,
    id,
    as,
    readOnly,
    autoComplete,
  } = props;
  return (
    <>
      <Form.Control
        autoComplete={autoComplete}
        as={as}
        id={id}
        placeholder={formPlaceholder}
        maxLength={max}
        aria-label={formAriaLabel}
        aria-describedby={describedBy}
        type={inputType}
        className={className}
        name={name}
        value={formik?.values[name] || value}
        checked={checked}
        disabled={disabled}
        readOnly={readOnly}
        rows={rows}
        onChange={(e) => formik?.setFieldValue(name, e.target?.value?.trimStart()) || onChange(e)}
        accept={accept}
        //{...formik?.getFieldProps(name)}
      />
      {showError && <FormInputError formik={formik} name={name} />}
    </>
  );
}

export const propTypes = {
  accept: PropTypes.string.isRequired,
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  formik: PropTypes.object,
  showError: PropTypes.bool,
  formPlaceholder: PropTypes.string,
  formAriaLabel: PropTypes.string,
  describedBy: PropTypes.string,
  inputType: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  rows: PropTypes.number,
  max: PropTypes.number,
  id: PropTypes.string,
  as: PropTypes.string,
  readOnly: PropTypes.bool,
  autoComplete: PropTypes.string,
};

FormInputControl.propTypes = propTypes;
export default FormInputControl;
